import {
  CmpTypographyField,
  CmpTextField,
  CmpSelectBox,
  CmpDatePicker,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
export default function WmsHead({
  xref,
  vRdxHead, 
}) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 4, sm: 0, md: 2 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className="align-items-center"
      >
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Sheet No"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xTextAlign="center"
            xtabIndex={"1"}
            xValue={vRdxHead.sheetID}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"SheetNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={  false}
            xErrorMessage={""}
          />
        </Grid>
       
         <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Assign bin"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"3"}
            // xValue={vRdxHead.ReferenceNo}
            xValue={vRdxHead.binName}
            xType={"text"} // text/number/password
            xName={"binName"}
            xReadOnly={true}
            xOnChange={()=>{

            }}
            xOnKeyUp={(e)=>{}}
            xError={false}
            xErrorMessage={""}
            xTextAlign="center"
          />
        </Grid>
       
      </Grid>
    </form>
  );
}
